module.exports = __webpack_public_path__ + "img/multi-two.4d1a4167.svg";